import { getLanding } from '~/api/service/common.service'
import type { LandingPageInfoModel } from '~/types/model/common.model'

export default defineNuxtRouteMiddleware(async (to) => {
  if (process.client) return
  const pathname = to.path

  let landingInfo: LandingPageInfoModel | null = null
  try {
    const data = await getLanding()
    landingInfo = data
  } catch {
    return
  }
  if (!landingInfo) return

  const isMaintenancePage = pathname === '/maintenance' || pathname.startsWith('/maintenance/')
  const isApiRoute = pathname.startsWith('/api')
  const isStaticFile = pathname.includes('.')
  const isNuxtInternal = pathname.startsWith('/_nuxt') || pathname.startsWith('/__nuxt')
  if (isMaintenancePage || isApiRoute || isStaticFile || isNuxtInternal) return

  return navigateTo('/maintenance', { replace: true, redirectCode: 307 })
})